'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  'object' == (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) && 'undefined' != typeof module ? module.exports = t() : 'function' == typeof define && define.amd ? define(t) : (e = e || self).formbridgeMaster = t();
}(undefined, function () {
  function e() {
    return (e = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var i = arguments[t];
        for (var n in i) {
          Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
        }
      }
      return e;
    }).apply(this, arguments);
  }
  var t = window.ActiveXObject || 'ActiveXObject' in window,
      i = function i() {
    return document.getElementsByTagName('body')[0];
  },
      n = function n(e) {
    var t = document.createElement('div');
    return t.innerHTML = e.trim(), t.firstChild;
  };
  return function () {
    function o(e) {
      var t = this;
      this._isReady = !1, this._uid = (null == e ? void 0 : e.key) || '', this._iframeElementId = 'iframe_content-' + this._uid, window.addEventListener('message', function (e) {
        var i = e.data,
            n = i.uid;
        n && t._uid !== n || 'close_dialog' === i.msg && (console.log('[master]: client is close...'), o.close());
      }.bind(this), !1);
    }
    o.close = function () {
      var e = document.getElementById('iframe_modal_content');
      if (t) {
        var n = i();
        n && n.removeChild(e);
      } else e && e.remove();
    };
    var d = o.prototype;
    return d.onReady = function (e) {
      e && e(), console.log('[master]: master is ready...'), this._isReady = !0;
    }, d.openSlot = function (t, i) {
      var o = e({}, { width: '100%', height: '100%', hideFooter: !1, style: '' }, i),
          d = '<iframe src="' + t + '" id="' + this._iframeElementId + '" key="' + this._uid + '" style=" display: block; ' + o.style + '" width="' + o.width + '" frameBorder="0" height="' + o.height + '" >\n    </iframe>',
          r = document.getElementById(o.containerId),
          a = document.getElementById(this._iframeElementId);
      r && !a && r.appendChild(n(d));
    }, d.openDialog = function (t, o) {
      var d = e({}, { width: '100%', height: '100%', hideFooter: !1, style: '' }, o),
          r = '\n    <div id="iframe_modal_content" >\n      <style>' + (d.hideFooter ? '.iframe_modal_footer{ display: none}' : '') + '</style>\n      <div style="position: fixed; top: 0; bottom: 0; left: 0; right: 0; background-color: #000; opacity: 0.75; z-index: 9999"></div>\n      <div style="position: fixed; top: 0; left: 10px; bottom: 0; right: 10px;  z-index: 10000" id="url_div_container">\n        <iframe src="' + t + '" id="' + this._iframeElementId + '" key="' + this._uid + '" style=" display: block; ' + d.style + '" width="' + d.width + '" frameBorder="0" height="' + d.height + '" >\n        </iframe>\n        <div style="text-align: right; padding: 16px;" class="iframe_modal_footer">\n          <button onclick="formBridgeMaster.close()" style="order-radius: 100px;\n          padding: 0 16px;\n          height: 36px;\n          line-height: 34px;\n          font-size: 14px;\n          border-radius: 5px;\n          border: none;\n          color: #fff;\n          background: #255bda;">确认</button>\n        </div>\n      </div>\n    </div>\n    ';
      if (!document.getElementById('iframe_modal_content')) {
        var a = i();
        a && a.appendChild(n(r));
      }
    }, d.open = function (e, t) {
      return this.openDialog(e, t);
    }, d.onClientReady = function (e) {
      var t = this;
      window.addEventListener('message', function i(n) {
        var o = n.data,
            d = o.uid;
        d && t._uid !== d || 'client_ready' === o.msg && (window.removeEventListener('message', i), console.log('[master]: client is ready...'), e && e(o));
      }.bind(this), !1);
    }, d.onReceiveData = function (e) {
      var t = this;
      window.addEventListener('message', function (i) {
        var n = i.data,
            o = n.uid;
        o && t._uid !== o || 'client_post_data' === n.msg && (console.log('[master]: 接收来自表单数据', n.data), e && e(n.data));
      }.bind(this), !1);
    }, d.postData = function (t) {
      var i = document.getElementById(this._iframeElementId);
      console.log('[master]: 向表单发送数据', t), i && i.contentWindow && i.contentWindow.postMessage(e({ uid: this._uid }, t), '*');
    }, o;
  }();
});
//# sourceMappingURL=formbridge-master.umd.js.map